import { OkToEnableScreenPayload } from '@usacsmideo/types';

export const okToEnableScreen = (payload: OkToEnableScreenPayload) => {
  const { nextScreenObject, updatedNavObj, chart } = payload;
  // CHECK IF ALL REQUIRED FIELDS ARE PRESENT
  if (!nextScreenObject || !updatedNavObj || !chart) {
    return 'Missing required information.';
  }

  // ONLY ENABLE THE THANKS PAGE AFTER THE USER HAS PAID
  if (nextScreenObject.id === 'thanks') {
    return 'ok';

    if (updatedNavObj.selfPay.completed === true || updatedNavObj.aob.completed === true) {
      return 'ok';
    }
    return 'Please complete payment section before attempting to continue.';
  }
  // ONLY ENABLE THE EDUCATION SECTION IF THE USER HAS SEEN THE THANKS SCREEN
  if (nextScreenObject.id === 'educationIndex') {
    return 'ok';

    if (updatedNavObj.thanks.completed === true) {
      return 'ok';
    }
    return 'Please complete payment section before attempting to continue.';
  }

  // ONLY ENABLE THE STATEMENT SECTION IF THE USER HAS COMPLETED ALL PATIENT EDUCATION
  if (nextScreenObject.id === 'statementIndex') {
    if (updatedNavObj.patientEducation.completed === true && updatedNavObj.treatmentOption.completed === true) {
      return 'ok';
    }
    return 'Please complete all required education sections before attempting to continue.';
  }

  if (nextScreenObject.id === 'recording') {
    if (updatedNavObj.attestation.completed === true) {
      return 'ok';
    }
    return 'Please complete the attestation section before attempting to continue.';
  }
  if (nextScreenObject.id === 'finalSignatures') {
    if (updatedNavObj.recording.completed === true) {
      return 'ok';
    }
    return 'Please record your video before attempting to continue.';
  }

  if (nextScreenObject.id === 'cardIndex') {
    if (updatedNavObj.recording.completed === true) {
      return 'ok';
    }
    return 'Please complete the recording section before attempting to continue.';
  }
  return 'function executed';
};
